import Locations from "@pages/Locations";
import LocationDetail from "@pages/Locations/Detail/Location";
import MapVendor from "@pages/Locations/Detail/Map/MapToVendor";
import LocationFunction from "@pages/Locations/Detail/Function";

export const LocationRoutes = [
	{ path: "/configuration/locations", name: "configuration_location", component: Locations  },
	{
		path: "/location/detail",
		name: "configuration_location",
		component: LocationDetail ,
	},
	{
		path: "/location/detail/:id",
		name: "configuration_location",
		component: LocationDetail ,
	},
	{
		path: "/location/map-vendor/:id",
		// name: "location_map_to_vendor",
		name:'configuration_location',
		component: MapVendor ,
	},
	{
		path: "/location/functions/:id",
		// name: "location_function",
		name:'configuration_location',
		component: LocationFunction ,
	}
]